module.exports = __webpack_public_path__ + "img/Uncle Iroh-256.ffc1cb4c.png";